//Keep all the Globally Reusable functions in this File.

export const globalFunctions = {
  getScreenWidth() {
    let values=[320, 480,600, 768, 900, 1024, 1200];
    switch(true) {
      case (screen.width < values[0]):   return 250; break;
      case (screen.width < values[1]):   return 350; break;
      case (screen.width < values[2]):   return 400; break;
      case (screen.width < values[3]):   return 500; break;
      case (screen.width < values[4]):   return 650; break;
      case (screen.width < values[5]):   return 850; break;
      case (screen.width < values[6]):   return 900; break;
      default: return 550;
    }
  },
}



// WEBPACK FOOTER //
// ./src/mixins/globalFunctions.js